import { render, staticRenderFns } from "./EmployeeCertificates.vue?vue&type=template&id=e130056c&scoped=true"
import script from "./EmployeeCertificates.vue?vue&type=script&lang=js"
export * from "./EmployeeCertificates.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCertificates.vue?vue&type=style&index=0&id=e130056c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e130056c",
  null
  
)

export default component.exports